<ng-container *ngIf="loading">
  <circle-spinner></circle-spinner>
</ng-container>
<nav #navbar class="navbar navbar-expand-lg" [ngClass]="{
    'bg-white': open === true,
    'navbar-transparent': open === false
  }">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" (click)="minimizeSidebar()">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle" (click)="sidebarToggle()">
        <button type="button" class="navbar-toggler">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <span class="navbar-brand text-uppercase">{{
        getTitleAdmin() | translate
        }}</span>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation"
      aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" (click)="open = !open">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <ul class="navbar-nav">
        <li class="nav-item btn-rotate dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            <p>
              <span class="">{{ "navbar.lang" | translate }}</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" (click)="changeLanguage('es')">ES</a>
            <a class="dropdown-item" (click)="changeLanguage('en')">EN</a>
          </div>
        </li>
        <li class="nav-item btn-rotate dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuAdjust" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuAdjust">
            <a class="dropdown-item" [routerLink]="['/superadmin-panel/settings/profile']">{{
              "menuItems.settings.profile" | translate }}</a>
            <!-- <a class="dropdown-item" [routerLink]="">{{
              "menuItems.settings.helpCenter" | translate
            }}</a> -->
            <a class="dropdown-item" (click)="logout()">{{
              "menuItems.settings.LogOut" | translate
              }}</a>
          </div>
        </li>
        <li class="d-flex-center">{{userName}}</li>
      </ul>
    </div>
  </div>
</nav>